import React from "react"
import PropTypes from "prop-types"
import {FormattedMessage} from "@irati/utils/lang"
import styled from "styled-components"
import {H5} from "@irati/ui/src/Headings"

const StyledSAMLKeyValue = styled.div`
  margin-bottom: 20px;
`

const SAMLKeyValue = ({value, namekey}) => (
  <StyledSAMLKeyValue>
    <H5>
      <FormattedMessage id="admin.components.samlKeyValue.value" values={{value}} />
    </H5>
    <H5>
      <FormattedMessage id="admin.components.samlKeyValue.nameKey" values={{namekey}} />
    </H5>
  </StyledSAMLKeyValue>
)

SAMLKeyValue.propTypes = {
  value: PropTypes.string,
  namekey: PropTypes.string
}
SAMLKeyValue.defaultProps = {
  value: null,
  namekey: null
}

export default SAMLKeyValue
